import { StockItemType } from '@/enums/StockItemType';
import { StockMovementType } from '@/enums/StockMovementType';
import { StockUnit } from '@/enums/StockUnit';
import { IDataOptions } from '@/interfaces/IDataOptions';
import { IPaginated } from '@/interfaces/IPaginated';
import { IStockItem } from '@/interfaces/IStockItem';
import { Globals } from '@/modules/Globals';
import axios from 'axios';

const apiUrl = Globals.apiPath + '/stock/items';

export interface ICreateStockItemDto {
  restaurantId: number;
  branchId: number;
  name: string;
  description: string;
  quantity: number;
  minimumQuantity: number;
  unit: StockUnit;
  type: StockItemType;
  cost: number;
}

export interface IUpdateStockItemDto extends ICreateStockItemDto {
  name: string;
  description: string;
  minimumQuantity: number;
  unit: StockUnit;
  type: StockItemType;
  cost: number;
}

export class StockItemsService {
  static async getAll({
    restaurantId,
    branchId,
    type,
    options,
  }: {
    restaurantId: number;
    branchId: number;
    type?: StockItemType | null;
    options?: IDataOptions;
  }) {
    const res = await axios.get<IPaginated<IStockItem>>(
      `${apiUrl}?r=${restaurantId}&b=${branchId}` +
        (type ? `&type=${type}` : '') +
        (options
          ? `&options=${encodeURIComponent(JSON.stringify(options))}`
          : '')
    );
    return res.data;
  }

  static async create(stockItem: ICreateStockItemDto) {
    const res = await axios.post<IStockItem>(apiUrl, stockItem);
    return res.data;
  }

  static async update(id: number, stockItem: IUpdateStockItemDto) {
    const res = await axios.put<IStockItem>(`${apiUrl}/${id}`, stockItem);
    return res.data;
  }

  static async delete(id: number) {
    const res = await axios.delete(`${apiUrl}/${id}`);
    return res.data;
  }

  static async adjustStock(data: {
    id: number;
    quantity: number;
    type: StockMovementType;
    action: 'add' | 'subtract' | 'adjust';
    note?: string;
  }) {
    const res = await axios.post(`${apiUrl}/${data.id}/adjust`, data);
    return res.data;
  }
}
